import scss from "./BasicTable.module.scss";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";

// Flatten the set -> groups -> attributes tree into a plain list of {id, name, valuesHtml}
// rows, ignoring group boundaries - the header-info position renders as individual grid
// items alongside Šifra/Lager, not as a grouped block.
function flattenSpecificationAttributes(specification) {
    const rows = [];
    (specification ?? []).forEach((data) => {
        Object.values(data?.groups ?? {}).forEach((item) => {
            Object.values(item?.attributes ?? {}).forEach((attribute) => {
                rows.push({
                    id: attribute?.attribute?.id,
                    name: attribute?.attribute?.name,
                    valuesHtml: (attribute?.values ?? []).map((value) => value.name).join(", "),
                });
            });
        });
    });
    return rows;
}

function formatDecimal(number) {
    if (Number.isInteger(number)) {
        return number.toString();
    }

    const decimal = number % 1;
    if (decimal === 0) {
        return number.toFixed(0);
    } else {
        return number.toFixed(2);
    }
}

const BasicTable = ({ productVariant, basic, headerSpecification, translateKey }) => {
    const { t } = useTranslation();

    let inventory = basic?.data?.item?.inventory ? basic?.data?.item?.inventory : false;
    let lager = basic?.data?.item?.inventory?.amount > 0 ? basic?.data?.item?.inventory?.amount : "-";
    let sku = basic?.data?.item?.basic_data?.sku;
    let barcode = basic?.data?.item?.basic_data?.barcode;
    let short_description = basic?.data?.item?.basic_data?.short_description;

    if ((productVariant && !Array.isArray(productVariant)) || (Array.isArray(productVariant) && productVariant?.length > 0)) {

        lager = productVariant?.inventory?.amount > 0 ? productVariant?.inventory?.amount : "-";
        inventory = productVariant?.inventory ? productVariant?.inventory : false;
        sku = productVariant?.basic_data?.sku ? productVariant?.basic_data?.sku : sku;
        barcode = productVariant?.basic_data?.barcode ? productVariant?.basic_data?.barcode : barcode;
        short_description = productVariant?.basic_data?.short_description ? productVariant?.basic_data?.short_description : short_description;
    }
    lager = parseFloat(lager);

    lager = formatDecimal(lager);

    const headerSpecificationRows = flattenSpecificationAttributes(headerSpecification);

    return (
        <div className={scss.container}>
            <div
                style={{
                    marginTop: "24px",
                    display: "grid",
                    gridTemplateColumns: `repeat(auto-fit, minmax(180px, 1fr))`,
                    gap: "16px",
                    alignItems: "start",
                }}
            >
                <div className={`${scss.data}`}>
                    <span className={scss.dataTitle}>{t(`${translateKey}-code`)}:</span>
                    <span className={scss.dataValue}>{sku}</span>
                </div>

                {barcode && (
                    <div className={`${scss.data}`}>
                        <span className={scss.dataTitle}>{t(`${translateKey}-barcode`)}:</span>
                        <span className={scss.dataValue}>{barcode}</span>
                    </div>
                )}
                {inventory && parse(inventory?.content?.html)}

                {headerSpecificationRows.map((row) => (
                    <div className={scss.data} key={row.id}>
                        <span className={scss.dataTitle} dangerouslySetInnerHTML={{ __html: `${row.name}:` }} />
                        <span className={scss.dataValue} dangerouslySetInnerHTML={{ __html: row.valuesHtml }} />
                    </div>
                ))}
            </div>

            {short_description && <div className={scss.wrapper} style={{ marginTop: "24px" }} dangerouslySetInnerHTML={{ __html: short_description }} />}
        </div>
    );
};

export default BasicTable;
